export default __webpack_public_path__ + "static/media/portugueses.faa27c88.svg";